/**
 * 定数を集めたファイル
 */
const constant = {
  WEEKDAYS: [
    '日曜日',
    '月曜日',
    '火曜日',
    '水曜日',
    '木曜日',
    '金曜日',
    '土曜日',
  ],
  WEEKDAYS_SHORT: ['日', '月', '火', '水', '木', '金', '土'],
  DATE_FORMAT: 'YYYY年MM月DD日',
  REG_NEWS_INFORMATION_URL: / \d{2}:\d{2}:\d{2}|-/g,
  BREADCRUMB_TOP_PAGE: {
    name: 'top',
    item: '/',
    position: '1',
  },
  SELF_B_LOGIN_PAGE_PATH: '/selfb/login/',
  HOW_TO_JOIN_AFB_PAGE_PATH: '/about-afb/entry/',
  SNS_URLS: {
    LINE: '/general/partner/line/',
    FACEBOOK: 'https://www.facebook.com/forit.affiliateb/',
    INSTAGRAM: 'https://www.instagram.com/afb.com_official/',
    X: 'https://twitter.com/affib_official',
  },
}

export default constant
